module.exports = require("nats/package.json");